import React from 'react';

export default function CreateConnectionButton({handleSubmit}) {
    return (
        <button onClick={handleSubmit} className="text-gray-800 bg-white mt-3 ml-5 hover:text-purple-500 font-semibold py-2 px-4 border border-gray-400 rounded shadow">
            Create Connection
        </button>
    )
}

CreateConnectionButton.defaultProps = {
    handleSubmit: null
}